import { StandaloneCheckout } from 'base/components/Checkout';
import { mergeProps } from '@/utils/merge';

const MabraStandaloneCheckout: typeof StandaloneCheckout = (props) => {
  return (
    <StandaloneCheckout
      {...mergeProps(
        {
          closed: {
            time: 'Sep 2 2024 00:00:00 GMT+0200',
            copy: 'Anmälan är nu stängd, håll utkik i våra kanaler för nästa tillfälle.',
          },
        },
        props
      )}
    />
  );
};

export default MabraStandaloneCheckout;
